module.exports = __webpack_public_path__ + "img/edit-icon.7f8f4da9.svg";